import PinchZoom from 'pinch-zoom-element';

const clampNumber = (num, min, max) => Math.min(Math.max(num, min), max);

const moveToSafeArea = function (currentPercentage) {
  const wrapper = document.querySelector('.product-fullscreen-pinchable-image');
  const wrapperWidth = wrapper.clientWidth;
  const wrapperHeight = document.documentElement.clientHeight;

  const content = wrapper.children[0];
  const contentWidth = content.clientWidth * wrapper.scale;
  const contentHeight = content.clientHeight * wrapper.scale;


  content.classList.add('moving');

  let safeX;
  let safeY;

  const safeRangeX = wrapperWidth - contentWidth;
  if (safeRangeX > 0) {
    safeX = Math.min(Math.max(wrapper.x, 0), safeRangeX);
  } else {
    safeX = Math.max(Math.min(wrapper.x, 0), safeRangeX);
  }

  const safeRangeY = wrapperHeight - contentHeight;
  if (safeRangeY > 0) {
    safeY = Math.min(Math.max(wrapper.y, 0), safeRangeY);
  } else {
    safeY = Math.max(Math.min(wrapper.y, 0), safeRangeY);
  }

  wrapper.setTransform({
    scale: wrapper.scale,
    x: safeX,
    y: safeY
  })

  setTimeout(() => {
    content.classList.remove('moving');
  }, 250)

}

const init = function() {
  const component = document.querySelector(".product-fullscreen-zoom");
  if (!component) return;

  const buttonsZoom = component.querySelectorAll('.product-zoom-button');
  const currentValue = component.querySelector('.product-zoom-current');
  const zoomImage = document.querySelector('.product-fullscreen-image');
  const zoomStep = 50;
  const minScale = 100;
  const maxScale = 200;
  let currentPercentage = 100;
  let referenceScale = 1;
  const pinchZoom = document.querySelector('.product-fullscreen-pinchable-image');
  const minusButton = component.querySelector('[data-zoom="minus"]');

  function setTransform(scale, x , y) {
    currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
    // moveToSafeArea(currentPercentage);
    if (!pinchZoom) return;
    
    const maxAllowedScale = (maxScale / 100) * referenceScale;
    const clampedScale = Math.min(scale, maxAllowedScale);
    const finalScale = Math.max(clampedScale, (minScale / 100) * referenceScale);
    
    // The x and y will be handled by our overridden setTransform
    pinchZoom.setTransform({
      scale: finalScale,
      x: x,
      y: y,
      allowChangeEvent: true
    });
    moveToSafeArea(currentPercentage);
  }

  function updateZoomDisplay() {
    currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
    currentValue.textContent = currentPercentage;
    minusButton.classList.toggle('disabled', currentPercentage <= minScale);
    minusButton.disabled = currentPercentage <= minScale;
  }

  pinchZoom.addEventListener('change', updateZoomDisplay);

  buttonsZoom.forEach(button => {
    button.addEventListener('click', function(e) {
      const currentScale = pinchZoom.scale;
      const currentDisplayPercentage = (currentScale / referenceScale) * 100;
      // const currentDisplayPercentage = (pinchZoom.scale / referenceScale) * 100;
      let targetDisplayPercentage = currentDisplayPercentage + 
        (e.target.dataset.zoom === "plus" ? zoomStep : -zoomStep);
      targetDisplayPercentage = clampNumber(targetDisplayPercentage, minScale, maxScale);
      // setTransform((targetDisplayPercentage / 100) * referenceScale);

      const targetScale = (targetDisplayPercentage / 100) * referenceScale;
      setTransform(
        targetScale,
        (window.innerWidth / 2) - ((zoomImage.clientWidth / 2) * targetScale),
        (window.innerHeight / 2) - ((zoomImage.clientHeight / 2) * targetScale)
      );
    });
  });

  function setInitialZoom() {
    currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
    moveToSafeArea(currentPercentage);
    if (!zoomImage || zoomImage.naturalWidth <= 0 || zoomImage.naturalHeight <= 0) return;

    referenceScale = Math.min(
      window.innerWidth / zoomImage.naturalWidth,
      window.innerHeight / zoomImage.naturalHeight
    );
    
    pinchZoom.minScale = referenceScale;

    // Apply the initial transform (fit to screen)
    setTransform(
      referenceScale,
      (window.innerWidth / 2) - ((zoomImage.clientWidth / 2) * referenceScale),
      (window.innerHeight / 2) - ((zoomImage.clientHeight / 2) * referenceScale)
    );
    
    // Update display to show 100%
    currentPercentage = 100;
    currentValue.textContent = currentPercentage;
  }
  pinchZoom.addEventListener('touchend', moveToSafeArea(currentPercentage));

  pinchZoom.addEventListener('wheel', (e) => {
    currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
    e.preventDefault();
    const currentScale = pinchZoom.scale;
    const currentDisplayPercentage = (currentScale / referenceScale) * 100;
    // const currentDisplayPercentage = (pinchZoom.scale / referenceScale) * 100;
    let targetDisplayPercentage = currentDisplayPercentage + (e.deltaY < 0 ? zoomStep : -zoomStep);
    targetDisplayPercentage = clampNumber(targetDisplayPercentage, minScale, maxScale);
    // setTransform((targetDisplayPercentage / 100) * referenceScale);
    if (targetDisplayPercentage !== currentDisplayPercentage) {
      const targetScale = (targetDisplayPercentage / 100) * referenceScale;
      setTransform(
        targetScale,
        (window.innerWidth / 2) - ((zoomImage.clientWidth / 2) * targetScale),
        (window.innerHeight / 2) - ((zoomImage.clientHeight / 2) * targetScale)
      );
    }

    // moveToSafeArea(currentPercentage);
  });

  pinchZoom.addEventListener('change', () => {
    currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
    const maxAllowedScale = (maxScale / 100) * referenceScale;
    if (pinchZoom.scale > maxAllowedScale) {
      // setTransform(maxAllowedScale);
      setTransform(
        maxAllowedScale,
        pinchZoom.x,
        pinchZoom.y
      );
    }
    moveToSafeArea(currentPercentage);
  });

  const observer = new MutationObserver(mutationList => {
    mutationList.forEach(mutation => {
      if (!mutation.attributeName.includes('src')) return;
      
      if (zoomImage.complete) {
        setInitialZoom();
      } else {
        zoomImage.addEventListener('load', setInitialZoom, { once: true });
      }
    });
  });
  
  observer.observe(zoomImage, { attributes: true });
  
  if (zoomImage.complete) {
    setInitialZoom();
  } else {
    zoomImage.addEventListener('load', setInitialZoom, { once: true });
  }
}

export {init};